<template>
  <div class="Affiche">            
    <a-scene
      xrextras-gesture-detector
      landing-page
      xrextras-loading
      xrextras-runtime-error
      renderer="colorManagement:true"
      xrweb="disableWorldTracking: true">
      <a-assets>
        <video
          id="romeos-video"
          ref="movie"
          autoplay
          playsinline
          crossorigin="anonymous"
          src="https://romeosgin-vitrine.dpt.media/static/romeos-muted.mp4">         
        </video>  
      </a-assets>
      <a-camera position="0 1 1"></a-camera>

      <a-entity target-video="name: affiche; video: #romeos-video;" v-if="target == null || target == 'affiche'">
        <a-plane height="1" width="1" position="0 1.1775 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="0 -1.1775 0" xrextras-hider-material></a-plane> 
        <a-entity 
          position="0 0 -.01"
          material="src: #romeos-video;"
          geometry="primitive: plane; height: 1.775; width: 1;">
        </a-entity>
       </a-entity>

      <a-entity target-video="name: poster; video: #romeos-video;" v-if="target == null || target == 'poster'">
        <a-plane height="1" width="1" position="0 1.22 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="0 -1.22 0" xrextras-hider-material></a-plane> 
        <a-entity 
          position="0 0 -.01"
          material="src: #romeos-video;"
          geometry="primitive: plane; height: 1.775; width: 1;">
        </a-entity>
       </a-entity>

    </a-scene> 

    <div class="Affiche__layers" :class="{ 'active': object_is_ready }">
      <div class="Affiche__scan" v-if="welcome"> 
        <div class="Affiche__witness">
          <img :src="require('@/commons/img/witness-small.png')"/>
        </div>
        <div class="Affiche__description">
          <div v-if="lang == 'en'">SCAN THE <span class="green">POSTER</span></div>
          <div v-else>SCANNE LA <span class="green">V</span>ITRINE</div>
        </div> 
      </div> 
    </div>
     
  </div>
</template>

<script>

import gsap from "gsap"

export default {

    name: 'Affiche',

    data: ()=>({
        target: null,
        welcome: false,
        presentation: false,
        sequence: false,
        buttons: false,
        scan_removed: false,
        presentation_completed: false,
        welcome_completed: false,
        use_sequence: false,
        object_is_ready: false,
        model: null,
        gbl: null
    }),

    beforeCreate() {


        AFRAME.registerComponent('target-video', {
            schema: {
                name: { type: 'string' },
                video: {type: 'string' },
            },
            // callback: (b)=> {
            //     this.onReady(b)
            // },

            xrimagescanningCompleted: ()=> {
              this.addWelcome()     
            },
            xrimagefoundCompleted: (dt_name , name)=> { 
              if(dt_name == name && this.target == null) {
                this.target = name
              }
              if(this.scan_removed == false){
                this.scan_removed = true
                this.removeScan()
              }
            },

            init: function () {
                const object3D = this.el.object3D
                      object3D.visible = false
                const name = this.data.name  
                const v = document.querySelector(this.data.video)
                const el = this.el
                const that = this
                const showImage = ({detail}) => {
                    if (name != detail.name) {
                        return
                    }
                    v.play()
                    object3D.position.copy(detail.position)
                    object3D.quaternion.copy(detail.rotation)
                    object3D.scale.set(detail.scale*.755, detail.scale*.755, detail.scale*.755)
                    object3D.visible = true
                    this.xrimagefoundCompleted(detail.name, this.data.name)
                }
                const hideImage = ({detail}) => {
                    if (name != detail.name) {
                        return
                    }
                    // v.pause() 
                    object3D.visible = false
                    // this.callback('false')
                }
                const xrimagescanning = (e)=> { 
                  this.xrimagescanningCompleted()
                }

                this.el.sceneEl.addEventListener('xrimagescanning', xrimagescanning)
                this.el.sceneEl.addEventListener('xrimagefound', showImage)
                this.el.sceneEl.addEventListener('xrimageupdated', showImage)
                this.el.sceneEl.addEventListener('xrimagelost', hideImage)
            }
        })
    },

    created() {
    },
    mounted() {
      // window.alert('muted')
    },

    methods: {

      removeScan() {
        gsap.to('.Affiche__scan', { 
          opacity: 0,
          duration: .25,
          onComplete: ()=>{ this.temporisation() } 
        })
      },

      addWelcome() {
        if(this.welcome == true) return
        this.welcome = true
        this.$nextTick(()=>{  
          gsap.from(['.Affiche__witness', '.Affiche__description'], 
            {   
              duration: .35,
              scale: .25, 
              ease: "back.out", 
              alpha: 0, 
              delay: 1.5,
              stagger: .25
            })
        })
      },
      temporisation() {
        gsap.delayedCall(.15, ()=> { 
          this.welcome = false 
        }) 
      }
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Affiche
  overflow hidden
  position absolute
  width 100%
  height 100%
  color white
  // background #409171
  font-family gotham

  &__load
    position fixed
    opacity 0
    top -500
  
  &__V  
    // width 60%
    width 30vh

  
  &__scan 
    position absolute
    display flex 
    flex-direction column
    align-items center
    justify-content center
    width 100%
    height 100%
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0

  &__description 
    font-size 22px 
    padding 24px
    position absolute

  &__layers 
    pointer-events none
    width 100% 
    height 100% 
    top 0px
    left 0px
    position fixed
    z-index 10000

    &.active 
      pointer-events auto

    &-animation 
    &-sequence
    &-buttons
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content center
      width 100%
      height 100%

    &-sequence 
      font-size 48px
      text-align center
      color black

    &-bottom 
      width 100%
      height 98px

    &-gif
      // width 60%
      width 30vh

    &-presentation
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content flex-start
      width 100%
      height 100%

    &-logo 
      // width 60%
      width 30vh

      &.padding
        padding-top 20%

    &-fvckrender
      // width 60%
      width 30vh
      padding-top 16px

      &.padding-bottom 
        // padding-bottom 16px
        padding-bottom 4vh

    &-plus 
      width 24px

    &-presente 
      padding-top 32px
      text-transform uppercase
      font-size 16px

    &-button
      // padding 12px 16px 0
      padding 2vh 4vh 0
      // width 50vh

  &__simulation 
    font-size 16px
    padding-top 32px
    color black

  &__video
    position absolute
    top 0
    left 0 
    opacity .6
    width 100%
    height 100%
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0
    
    & video 
      width 100vw 
      object-fit fill

.green 
  color #64c39e

#requestingCameraPermissions 
  color black
  background-color black
  opacity 0
  position absolute 
  width 1000px

.poweredby-img
  opacity 0 !important
  display none

.button-primary-8w 
  background-color green
  color #fff

</style>














